<template>

        <header id="active-sticky" class="header-section">
            <div class="container">
                <div class="align-items-center topall">
                    <!-- logo 区域 -->
                    <div class="col">
                        <div class="header-logo">
                            <a href="/"><img :src="logo" alt="Site Logo" class="logo" /></a>
                        </div>
                    </div>

                    <!-- 导航菜单区域（新增 nav-col 类，实现靠左对齐） -->
                    <div class="col nav-col">
                        <!-- 桌面端菜单：窗口缩小自动隐藏 -->
                        <nav class="main-menu hide-on-small">
                            <el-menu :default-active="$route.path" active-text-color="rgba(11, 124, 245, 1)"
                                text-color="rgba(56, 56, 56, 1)" class="el-menu-demo" mode="horizontal" :router="true">
                                <el-menu-item index="/">首页</el-menu-item>
                                <el-menu-item index="/price">套餐购买</el-menu-item>
                                <el-menu-item index="/getip">API提取</el-menu-item>
                                <el-menu-item index="/news">新闻资讯</el-menu-item>
                                <el-menu-item index="/help">帮助指南</el-menu-item>
                            </el-menu>
                        </nav>

                        <!-- 汉堡按钮：移动端显示 -->
                        <el-button class="toggle" icon="el-icon-menu" @click="drawer = true">
                        </el-button>

                        <!-- 移动端抽屉菜单 -->
                        <el-drawer :visible.sync="drawer" :modal="false" class="el-hidden-lg-only">
                            <template slot="title">
                                <img :src="logo" alt="logo" style="width: 50px" />
                            </template>
                            <nav id="offcanvasNav" class="offcanvas-menu">
                                <ul>
                                    <li><a href="/">首页</a></li>
                                    <li><a href="/price">套餐购买</a></li>
                                    <li><a href="/getip">API提取</a></li>
                                    <li><a href="/news">新闻资讯</a></li>
                                    <li><a href="/help">帮助指南</a></li>
                                </ul>
                                <div class="btn-group">
                                    <div v-if="isShow">
                                        <el-button @click="toLogin(0)" class="login"> 登 录 </el-button>
                                        <el-button class="elbutton2" @click="toLogin(1)" plain type="primary"> 注册免费试用
                                        </el-button>
                                    </div>
                                    <div v-else>
                                        <el-button @click="toadmin" type="primary"> 会 员 中 心 </el-button>
                                        <el-button type="danger" @click="loginout()"> 退 出 </el-button>
                                    </div>
                                </div>
                            </nav>
                        </el-drawer>
                    </div>

                    <!-- 右侧登录按钮组：桌面端显示 -->
                    <div class="hide-on-small s-right">
                        <div v-if="isShow">
                            <el-button @click="toLogin(0)" class="login"> 登录 </el-button>
                            <el-button class="elbutton2" @click="toLogin(1)" plain type="primary"> 注册 </el-button>
                        </div>
                        <div v-else>
                            <el-button @click="toadmin" type="primary"> 会员中心 </el-button>
                            <el-button type="danger" @click="loginout()"> 退出 </el-button>
                        </div>
                    </div>
                </div>
            </div>
            <loginDialog ref="login"></loginDialog>
        </header>

</template>

<script>
import loginDialog from '@/components/loginView'
import ThemeSwitch from '@/components/ThemeSwitch.vue'

export default {
    components: {
        loginDialog,
        ThemeSwitch
    },
    data() {
        return {
            banner: '',
            logo: require('@/assets/img/s/ps7daili.png'),
            hide: true,
            isShow: true,
            drawer: false,
            flag: false
        }
    },
    created() {
        this.$bus.$on('isShow', (val) => {
            this.isShow = val
        })
        if (window.sessionStorage.getItem('token')) {
            this.isShow = false
        } else {
            this.isShow = true
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll, true)
        window.addEventListener('setItem', () => {
            this.logo = sessionStorage.getItem('logo')
        })
        this.banner = window.sessionStorage.getItem('banner')
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll, true)
    },
    methods: {
        // 滚动吸顶逻辑
        handleScroll() {
            const scrolltop = document.documentElement.scrollTop || document.body.scrollTop
            if (scrolltop > 30) {
                document.getElementById('active-sticky').classList.add('is-sticky')
                document.getElementById('active-sticky').style.top = '0px'
            } else {
                document.getElementById('active-sticky').classList.remove('is-sticky')
                if (this.banner) {
                    document.getElementById('active-sticky').style.top = '0px'
                }
            }
        },
        toClose() {
            this.banner = ''
        },
        // 移动端菜单展开收起
        isOpen(e) {
            if (this.flag) {
                e.currentTarget.parentElement.classList.remove('active')
                this.flag = false
            } else {
                e.currentTarget.parentElement.classList.add('active')
                this.flag = true
            }
        },
        // 打开登录弹窗
        toLogin(e) {

            // if (window.location.hostname.includes('ip.dataip.com.cn')) {
            //     window.location.href = 'https://7daili.com'
            //     return
            // }

            this.$refs.login && this.$refs.login.openDialog()
            sessionStorage.setItem('checked', e)
        },
        // 跳转会员中心
        toadmin() {
            this.$router.push('/admin')
        },
        // 退出登录
        loginout() {
            this.$confirm('此操作将登出当前账号, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$apiFun.logout().then((res) => {
                        if (res.code == 1) {
                            sessionStorage.removeItem('token')
                            this.isShow = true
                            this.$message.success('登出成功!')
                            location.reload()
                        }
                    })
                })
                .catch(() => {
                    this.isShow = false
                    this.$message({
                        type: 'info',
                        message: '已取消登出'
                    })
                })
        }
    }
}
</script>

<style lang="scss" scoped>
/* ===== 核心修改：导航靠左对齐 ===== */
.nav-col {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 30px;
    /* logo与菜单的间距，可按需调整 */
}

/* 移动端汉堡按钮靠右 */
.toggle {
    margin-left: auto;
}

/* 第一个菜单项去掉左侧外边距，更贴合左侧 */
::v-deep .el-menu--horizontal>.el-menu-item:first-child {
    margin-left: 0;
}

/* ================================ */

::v-deep .container {
    .topall {
        .header-logo {
            padding-bottom: 1px;
        }

        .main-menu {
            .el-menu-demo {
                .el-menu-item {
                    height: 3.5rem;
                }
            }
        }

        .btn-group {
            margin: 10px !important;
            display: flex;
            justify-content: space-between !important;
            align-items: center;
            width: 100%;
        }

        .s-right {
            .login {
                width: 5.75rem;
                height: 1.875rem;
                border-radius: 0.25rem;
                border: 1px solid rgba(11, 124, 245, 1);
                padding: 0;

                span {
                    font-size: 1rem;
                    font-weight: 500;
                    color: rgba(11, 124, 245, 1);
                }
            }

            .elbutton2 {
                width: 8.25rem;
                height: 2rem;
                padding: 0;
                opacity: 1;
                border-radius: 0.25rem;
                background: linear-gradient(90deg, rgba(11, 124, 245, 1) 0%, rgba(8, 201, 143, 1) 100%);

                span {
                    font-size: 1rem;
                    font-weight: 500;
                    color: rgba(255, 255, 255, 1);
                }
            }
        }
    }
}
</style>

<style scoped>
.logo {
    width: 120px;
}

/* 响应式：小屏隐藏桌面菜单 */
@media (max-width: 992px) {
    .hide-on-small {
        display: none !important;
    }
}

/* 响应式：大屏隐藏汉堡按钮 */
@media (min-width: 993px) {
    .toggle {
        display: none !important;
    }
}

.header-section {
    padding: 0;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
    background-color: white;
}

.is-sticky {
    background-color: rgba(255, 255, 255, 1);
}

.topall {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.is-show {
    opacity: 0;
}

.login {
    border-color: #409eff;
    color: #409eff;
}

::v-deep .el-button--primary.is-plain {
    background: linear-gradient(45deg, rgba(11, 124, 245, 1), rgba(8, 201, 143, 1));
    color: #fff;
}

.ad {
    height: 60px;
    width: 100%;
    z-index: 999;
    position: fixed;
    top: 0;
}

.ad_bg {
    display: none;
}

.close {
    padding: 4px;
    background-color: #efefef11;
    color: #fff;
    font-weight: bold;
    position: absolute;
    right: 20px;
    top: 18px;
    cursor: pointer;
    z-index: 9999;
}

::v-deep .el-menu {
    background-color: transparent;
}

::v-deep .el-menu--horizontal>.el-menu-item {
    font-size: 16px;
    font-weight: 500;
    padding: 0;
    margin: 0 15px;
}

::v-deep .el-submenu__title {
    font-size: 16px;
    font-weight: 500;
    padding: 0;
    margin: 0 15px;
}

::v-deep .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover {
    background-color: transparent;
}

::v-deep .el-menu.el-menu--horizontal {
    border: none;
}
</style>